import { IFileWithPreview } from 'types/IFileWithPreview';

export const isVideo = (file: unknown): file is IFileWithPreview =>
  (file as IFileWithPreview)?.preview !== undefined &&
  (file as IFileWithPreview).name !== undefined &&
  (file as IFileWithPreview).lastModified !== undefined &&
  (file as IFileWithPreview).path !== undefined;
